import React from 'react';
import { Icon } from '@iwoca/orion';
import Tippy from '@tippyjs/react';

import styles from './Tooltip.module.css';
import 'tippy.js/dist/tippy.css';
import 'tippy.js/themes/light.css';

type TooltipPropTypes = {
  id?: string;
  value: string;
  children?: React.ReactNode;
};

/** Note: Current tooltip is used only for AG-Grid related items due to each cell now allowing elements to overflow. Tooltips needs to render from outside the table. */
export const Tooltip = ({ id, value, children }: TooltipPropTypes) => {
  if (!value) {
    return <></>;
  }

  const renderTooltipContent = () => {
    return (
      <div className={styles.tooltipContent} data-testid="tooltip-content">
        {value}
      </div>
    );
  };

  const testId = `tooltip-trigger${id ? `-${id}` : ''}`;
  return (
    <Tippy
      className={styles.tooltipPopup}
      content={renderTooltipContent()}
      theme="light"
      interactive={false}
      arrow={true}
      placement="bottom"
    >
      <div data-testid={testId} className={styles.tooltipContainer}>
        {children || (
          <Icon icon="questionMarkFilled" className={styles.tooltipTrigger} />
        )}
      </div>
    </Tippy>
  );
};
